"use client";

import { createT } from "@/app/[lang]/_utils/create-t";
import type { Lang } from "@/langs";
import { Button } from "@borderless/ui/components/button";
import { useActionState, useEffect, type FC } from "react";
import { useFormStatus } from "react-dom";
import { openBillingPortal } from "./open-billing-portal";
import dictionary from "./t.json";

const t = createT(dictionary);

const BillingPortalOpenButton: FC<{
  lang: Lang;
}> = (props) => {
  const { pending } = useFormStatus();
  return (
    <Button variant="link" size="sm" type="submit" disabled={pending}>
      <span className="shrink-0">{t("Billing Portal", props.lang)}</span>
    </Button>
  );
};
const initialState = {
  error: "",
};
export const BillingPortalButtonClient: FC<{
  lang: Lang;
}> = (props) => {
  const [state, formAction] = useActionState(openBillingPortal, initialState);
  useEffect(() => {
    if (state.error) {
      alert(state.error);
    }
  }, [state]);
  return (
    <form action={formAction}>
      <BillingPortalOpenButton {...props} />
      <p aria-live="polite" className="sr-only" role="status">
        {state.error}
      </p>
    </form>
  );
};
